// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-data-table[data-v-1226c201] .v-data-table__wrapper tbody tr:nth-child(odd) {\n    background-color: #fafafa;\n}\n.v-chip--small[data-v-1226c201] {\n    height: 24px !important;\n}\n", ""]);
// Exports
module.exports = exports;
